import { render } from "./M3.vue?vue&type=template&id=20c6bb72&scoped=true"
import script from "./M3.vue?vue&type=script&lang=js"
export * from "./M3.vue?vue&type=script&lang=js"

import "./M3.vue?vue&type=style&index=0&id=20c6bb72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c6bb72"]])

export default __exports__